<div fxFlex.gt-md="60" fxFlex *ngIf="imageVisible" style="border: 1px dotted #ddd;
border-radius: 0px;padding: 15px 10px;" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <div fxLayout="column">

    <div fxLayout="row" fxLayoutGap="10px">

      <span fxLayoutAlign="start center">
        {{group.value[field.attributeCode]}}
        <button [attr.guide]="'file-upload-g-btn-1' + '__' + sanitizeUrl(url)" (click)="download()" color="warn" mat-icon-button type="button">
          <mat-icon>download

          </mat-icon>

        </button>

      </span>

      <ng-container fxLayoutAlign="end center">
        <button [attr.guide]="'file-upload-g-btn-2' + '__' + sanitizeUrl(url)" (click)="logo()" mat-raised-button>Upload</button>

        <button [attr.guide]="'file-upload-g-btn-3' + '__' + sanitizeUrl(url)" *ngIf="value!=''" (click)="deleteImage(0)" mat-raised-button>delete</button>
      </ng-container>

    </div>
  </div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;"
  fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <calsoft-common-file-upload-pdf (fileUploadResult)=getResult($event) [type]="'gallery'">
  </calsoft-common-file-upload-pdf>
  <button [attr.guide]="'file-upload-g-btn-4' + '__' + sanitizeUrl(url)" (click)="cancelUpload()" mat-raised-button>Cancel</button>
</div>